import { TransformDate } from '../../../decorators/transform-date.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { CountryDto } from '../../settings/dtos/country.dto';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Reservation Contact DTO
 */
export class ReservationContactDto {
	@TransformInt()
	id?: number;
	@TransformDate()
	arrivalAt?: Date;
	arrivalAirportName?: string;
	arrivalFlightNumber?: string;
	@TransformDate()
	departureAt?: Date;
	departureAirportName?: string;
	departureFlightNumber?: string;
	address1?: string;
	address2?: string;
	phoneLandline?: string;
	phoneMobile?: string;
	phoneFax?: string;
	city?: string;
	postCode?: string;
	poBox?: string;
	county?: string;
	state?: string;
	@TransformInt()
	countryId?: number;
	country?: CountryDto;
}
